import AccessTimeIcon from "@mui/icons-material/AccessTime";
import React, { Key, useState } from "react";
import { LeaderDonor } from "types";
import { formatCampaignDateRange } from "utils/helpers/formatCampaignDateRange";
import * as S from "./index.styles";
import { useDispatch } from "react-redux";
import { updateShowDonationAmountScreen } from "store/ui/donationAmountScreen/donationAmountScreen.slice";
import { useAppSelector } from "store/hooks";
import DonationAmountModal from "views/DonateFlow/DonationAmountModal/DonationAmountModal";
import { Activity } from "store/campaigns/campaignActivities/campaignActivities.types";
import TopDonorsList from "components/DonationDetails/TopDonorsList";


interface Props {
  current: number;
  goal: number;
  startDate: string;
  endDate: string;
  donors: LeaderDonor[];
  campaignId: string;
  activities: Activity[];
}

const FundraisingStats: React.FC<Props> = ({
  current = 0,
  goal = 0,
  startDate = "",
  endDate = "",
  donors = [],
  campaignId = "",
  activities = [],
}) => {
  const [showAllDonors, setShowAllDonors] = useState(false);
  const percent = goal ? Math.min(100, (current / goal) * 100) : 0;
  const totalDonors = donors.length;
  const daysLeft = Math.max(
    0,
    Math.ceil((new Date(endDate).getTime() - Date.now()) / 86_400_000)
  );
  const displayedDonors = showAllDonors ? donors : donors.slice(0, 3);
  const dispatch = useDispatch();
  const showDonationAmount = useAppSelector(
    (state) => state.showDonationAmount.show
  );

  const mappedDonors = donors.map((d) => ({
    id: d.id,
    avatar: d.avatar,
    name: d.name,
    date: d.date,
    amount: d.amount,
    isAnonymous: d.anon === 1,
    displayAmount: d.display_donation !== 0,
  }));

  return (
    <S.StatsSection>
      <S.StatsHeaderRow>
        <div />
        {/*<S.SeeDetails onClick={() => console.log("details")}>
          See details
        </S.SeeDetails>*/}
      </S.StatsHeaderRow>
      <S.AmountRow>
        <S.BigAmount>
          ${current ? current.toLocaleString("en-US") : "0"}
        </S.BigAmount>
        <S.GoalText>pledged of {goal.toLocaleString("en-US")} goal</S.GoalText>
      </S.AmountRow>

      <S.ProgressBarBackground>
        <S.ProgressBarFill percent={+percent} />
      </S.ProgressBarBackground>

      <S.KpiGrid>
        <S.KpiBox>
          <S.KpiValue>{totalDonors.toLocaleString("en-US")}</S.KpiValue>
          <S.KpiLabel>Total donors</S.KpiLabel>
        </S.KpiBox>
        <S.KpiBox>
          <S.KpiValue>{daysLeft.toLocaleString("en-US")}</S.KpiValue>
          <S.KpiLabel>Days to go</S.KpiLabel>
        </S.KpiBox>
      </S.KpiGrid>

      <S.DateBox>
        <AccessTimeIcon sx={{ fontSize: 22 }} />
        <span>
          {startDate && endDate
            ? formatCampaignDateRange(startDate, endDate)
            : "—"}
        </span>{" "}
      </S.DateBox>

      <S.DonateButtonPink
        onClick={() => {
            console.log(activities)
            dispatch(updateShowDonationAmountScreen({
                show: true,
                activityId: activities[0]?.id,
                campaignShort: campaignId,
              })
            )
          }
        }
      >
        Donate Now
      </S.DonateButtonPink>

      <S.Hr />

      <TopDonorsList title="Top donors" donors={mappedDonors} donorsToShowInitially={3}/>
      {showDonationAmount ? <DonationAmountModal /> : null}
    </S.StatsSection>
  );
};

export default FundraisingStats;
